export type TrackingDataLayerItem = Record<string, unknown> | unknown[];

/**
 * Public measurement identifiers copied from the current production site.
 * Environment variables can override the production identifiers. Local, LAN,
 * staging and preview hosts never load these providers.
 */
export const tracking = {
  ga4MeasurementId: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID ?? "G-35W6B9GRPH",
  gtmId: process.env.NEXT_PUBLIC_GTM_ID ?? "GTM-TB2FV8Z",
  clarityProjectId: process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID ?? "k8w3rnrxzi",
  googleAdsId: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID ?? "AW-11085769592",
  /** HubSpot portal 247709017 is hosted in the na2 data center. */
  hubspotPortalId: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID ?? "247709017",
  hubspotScriptHost: process.env.NEXT_PUBLIC_HUBSPOT_SCRIPT_HOST ?? "js-na2.hs-scripts.com",
} as const;
